<template>
  <b-modal
    :id="id"
    :title="title"
    :ok-title="trans('save')"
    :cancel-title="trans('cancel')"
    no-close-on-backdrop
    size="lg"
    @ok="onSave"
    @shown="loadItems"
    @hidden="$emit('hidden')"
    :ok-disabled="busy"
  >
    <b-row>
      <b-col>
        <p class="lead">{{ trans('drag_drop_to_reorder') }}</p>
      </b-col>
      <b-col class="col-auto">
        <b-button variant="outline-primary" size="sm" @click="onSortAsc">
          <i class="fa fa-fw fa-sort-alpha-down"></i>
          {{ trans('sort') }}
        </b-button>
      </b-col>
    </b-row>

    <b-list-group v-if="!!items" class="mb-3" style="max-height: 70vh; overflow-y: auto;">
      <draggable v-model="items" group="items" @start="drag=true" @end="drag=false">
        <b-list-group-item v-for="(item, index) in items" :key="index" style="cursor: pointer;">
          <i class="fa fa-fw fa-bars text-muted"></i>
          <slot name="item" v-bind:item="item.item">
            {{ item.text }}
          </slot>
        </b-list-group-item>
      </draggable>
    </b-list-group>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    props: {
      id: {
        type: String,
        default: 'reorder-modal',
      },
      title: {
        type: String,
        default: trans('reorder_items')
      },
      nameAttribute: {
        type: String,
        default: 'name',
      },
      orderAttribute: {
        type: String,
        default: 'order',
      },
      propItems: Array,
      getUrl: String,
      saveUrl: String,
    },
    components: {
      draggable,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        items: null,
      }
    },
    methods: {
      onSortAsc() {
        if (this.orderAttribute == 'date') {
          this.items = _.sortBy(this.items, 'item.date')
        }
        else this.items = _.sortBy(this.items, 'text')
      },
      onSave(e) {
        if (!this.saveUrl) {
          this.$emit('saved', this.items)
          this.$bvModal.hide(this.id)
          return
        }

        e.preventDefault()
        this.busy = true
        this.error = null
        axios.post(this.saveUrl, {ids: _.map(this.items, 'id')})
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide(this.id)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
      loadItems() {
        if (this.propItems) {
          this.items = _.map(this.propItems, o => {
            return {
              id: o.id,
              text: o[this.nameAttribute],
              item: o,
            }
          })
          return
        }

        this.busy = true
        this.error = null
        this.items = null
        axios.get(this.getUrl)
        .then(response => {
          this.busy = false
          this.items = _.map(response.data.data ? response.data.data : response.data, o => {
            return {
              id: o.id,
              text: o[this.nameAttribute],
              item: o,
            }
          })
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      }
    },
    mounted() {
      window[_.camelCase(this.id)] = this
    },
  }
</script>
